<template>
  <div class="successed-box">
    <van-icon color="#3acd22" name="checked" size="120" />
    <p class="tip">恭喜您，设置成功！</p>
    <p class="warm">需缴纳会员费成为正式会员</p>
    <van-button class="loginBtn" type="primary" size="large" @click="go('login')">立即登录</van-button>
  </div>
</template>

<script>
import { Icon, Button } from "vant";

export default {
  data() {
    return {};
  },
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button
  },
  methods: {
    go(pathName) {
      this.$router.push({ name: pathName });
    }
  }
};
</script>

<style lang="less" scoped>
.successed-box {
  padding-top: 15px;
  text-align: center;
  .tip {
    font-size: 16px;
    color: #3acd22;
  }
  .warm {
    margin-top: 20px;
    font-size: 14px;
    color: #999;
  }
  .loginBtn {
    margin-top: 55px;
  }
}

</style>
